import { Modal, SelectInput } from 'melp-design/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'store/modal';
import { useEmployeeGroups } from 'store/employee-groups';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';

interface Values {
  groupId: string;
}

interface Props extends ModalProps {
  title?: string;
  closeModal: (
    param?: { action: 'CLOSE' } | { action: 'CONFIRM'; groupId: string },
  ) => void;
}

export const EmployeesGroupSelectModal: FC<Props> = ({ closeModal, title }) => {
  const { t } = useTranslation();

  const { data: employeesGroups, isLoading } = useEmployeeGroups();

  const { handleSubmit, control } = useForm<Values>({
    defaultValues: { groupId: '' },
  });

  const onSubmit: SubmitHandler<Values> = (values) => {
    closeModal({ action: 'CONFIRM', groupId: values.groupId });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={title || t('employees.select')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
            disabled: isLoading,
          },
        ]}
      >
        <Controller
          name="groupId"
          control={control}
          render={({ field: { name, value, onChange, ref } }) => {
            return (
              <SelectInput
                label={t('entity_type.employeeGroup')}
                name={name}
                value={value}
                onChange={onChange}
                options={
                  employeesGroups?.items.map((group) => ({
                    label: group.name,
                    value: group.id,
                  })) ?? []
                }
                required
                ref={ref}
              />
            );
          }}
        />
      </Modal.Content>
    </form>
  );
};
